var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button-group',{staticClass:"align__right"},[_c('el-button',{attrs:{"size":"small","type":"primary","disabled":_vm.navi_disable},on:{"click":_vm.preMonth}},[_vm._v("\n      Previous Month\n    ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary","disabled":_vm.navi_disable},on:{"click":_vm.nextMonth}},[_vm._v("\n      Next Month\n    ")])],1),_vm._v(" "),_c('FullCalendar',{ref:"fullCalendar",staticClass:"kpisCalendar",attrs:{"default-view":"dayGridMonth","header":{
      left: '',
      center: 'title',
      right: '',
    },"plugins":_vm.calendarPlugins,"events":_vm.calendarEvents},on:{"eventRender":_vm.eventRender}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }